import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import SisLoader from "../../../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../../../widgets/AppToast";
import CargoCraneTable from "../../components/CargoCraneCom/CargoCraneRow";
import AddCargoCraneModal from "../../components/CargoCraneCom/AddCargoCraneModal";

function CargoCrane({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [errors, set_errors] = useState({});

  // List Cargo Crane API
  const listCargoCraneData = () => {
    const formData = new FormData();
    formData.append("ship_id", id);
    try {
      post(ApiURL.list_cargo_crane_details_com, formData).then((res) => {
        if (res?.status === true) {
          setFilteredData(res?.crane_parameters_data || []);
        }
      });
    } catch (error) {
      console.error("Error fetching Cargo Crane list:", error);
    }
  };

  useEffect(() => {
    listCargoCraneData();
  }, []);

  // Add Cargo Crane API
  const addCargoCraneData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("ship_id", id);
      formData.append("crane_name", data?.crane_name);
      formData.append("crane_maker", data?.crane_maker);
      formData.append("crane_model", data?.crane_model);
      formData.append("machinery_type", data?.machinery_dropdown);
      formData.append(
        "selected_parameters",
        JSON.stringify(data?.selectedParams)
      );
      formData.append("other_parameters", JSON.stringify(data?.customParams));
      post(ApiURL.add_cargo_crane_details_com, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast("Cargo Crane Details Saved!", "Cargo Crane Details Successfully Added!");
          listCargoCraneData();
          setIsModalOpen(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      set_loader(false);
      console.error("Error occurred while adding Cargo Crane details:", error);
    }
  };
  // Update Cargo Crane API
  const updateCargoCraneData = (data) => {
    set_loader(true);
    try {
      const formData = new FormData();
      formData.append("id", data?.id);
      formData.append("ship_id", id);
      formData.append("crane_name", data?.crane_name);
      formData.append("crane_maker", data?.crane_maker);
      formData.append("crane_model", data?.crane_model);
      formData.append("machinery_type", data?.machinery_dropdown);
      formData.append("selected_parameters", JSON.stringify(data?.selectedParams));
      formData.append("other_parameters", JSON.stringify(data?.customParams));
      formData.append("request_type", "add-edit");

      post(ApiURL.update_cargo_crane_details, formData).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", res?.message || "Cargo Crane Details Updated Successfully!");
          setIsModalOpen(false);
          listCargoCraneData();
          if (onSuccess) onSuccess();
          set_errors({});
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      console.error("Error occurred while updating Cargo Crane details:", error);
      set_loader(false);
    }
  };

  const VIEW_API = (data) => {
    try {
      const formData = new FormData();
      formData.append("ship_id", id);
      formData.append("id", data?.id);
      formData.append("request_type", "view");
      post(ApiURL.view_cargo_crane_details_com, formData).then((res) => {
        if (res?.status === true) {
          setResponseData(res?.cargo_machinery_data || {});
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      console.error("Error viewing Cargo Crane details:", error);
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>Cargo Crane Information</h3>
        <Button
          type="primary"
          onClick={() => setIsModalOpen(true)}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add Cargo Crane
        </Button>
        <AddCargoCraneModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responseData?.id) {
              updateCargoCraneData({ ...data, id: responseData.id });
            } else {
              addCargoCraneData(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponseData({});
            set_errors({});
          }}
          responseData={responseData}
          errors={errors}
        />
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {filteredData?.length > 0 ? (
              <CargoCraneTable data={filteredData} onEdit={(row) => VIEW_API(row)} />
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default CargoCrane;
